import { render, staticRenderFns } from "./wt-checkbox.vue?vue&type=template&id=0e2e6fc9"
import script from "./wt-checkbox.vue?vue&type=script&lang=js"
export * from "./wt-checkbox.vue?vue&type=script&lang=js"
import style0 from "./wt-checkbox.vue?vue&type=style&index=0&id=0e2e6fc9&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports